import { isNonEmptyObject } from "_helpers";

export function defineSize( initialSize ) {
    switch(initialSize){
        case "sm" :
        case "small" :
            initialSize = "small";
            break;
        case "md" :
        case "middle" :
        case "medium" :
            initialSize = "middle";
            break;
        case "lg" :
        case "large" :
            initialSize = "large";
            break;
        default : 
            initialSize = "middle";
            break;
    }

    return initialSize;
}

export function defineBadgeRibbon( activity ) {
    let text, color;

    switch(activity){
        case "high":
            text = "Activité élevée";
            color = "red";
            break;
        case "medium": 
            text = "Activité modérée";
            color = "orange";
            break;
        case "low": 
            text = "Activité faible";
            color = "blue";
            break;
        default:
            break;
    }

    return {
        text, 
        color
    };
}

export function defineTagColor( status = null ) {
    return status === 'OK' ? 'bdg-success' : status === 'KO' ? 'bdg-error' : 'bdg-grey';
}

export function defineCardBgColor( values ) {
    let colors = {
        c1: 'green',
        c2: 'green',
        c3: 'green',
        c4: 'green'
    };

    if( isNonEmptyObject(values) ){
        const { apilog, envelope, email = {}, sms = {} } = values,
            { inbox: ein, outbox: eout } = email,
            { inbox: sin, outbox: sout } = sms;

        if( colors.c1 === 'green' && apilog?.status === 'KO' ) colors.c1 = 'red';
        if( colors.c2 === 'green' && envelope?.status === 'KO' ) colors.c2 = 'red';
        if( colors.c3 === 'green' && (ein?.status === 'KO' || eout?.status === 'KO') ) colors.c3 = 'red';
        if( colors.c4 === 'green' && (sin?.status === 'KO' || sout?.status === 'KO') ) colors.c4 = 'red';
    }

    return Object.values(colors).some(el => el === 'red') && '3px solid red';
}